import React from "react";
import Marquee from "react-fast-marquee";
import { ShieldCheck, FileText } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Kicker } from "@/components/Reveal";
import { CERT_FILES } from "@/data/content";

const Quality = () => {
  const { t, dir } = useLang();

  return (
    <section id="quality" data-testid="quality-section" className="py-24 md:py-32 bg-[#F5F2EB]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-8">
            <Reveal><Kicker>{t.quality.kicker}</Kicker></Reveal>
            <Reveal delay={0.1}>
              <h2
                style={{ lineHeight: dir === "rtl" ? 1.25 : 1.1 }}
                className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#1A1A1A] mt-5"
              >
                {t.quality.title}
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-4">
            <Reveal delay={0.15}>
              <p className="text-base md:text-lg text-[#4A4A4A] leading-relaxed">{t.quality.text}</p>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {t.quality.certs.map((c, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <a
                href={CERT_FILES[i]}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`cert-${i}`}
                className="group bg-white border border-[#E5DFD3] p-10 flex flex-col items-start gap-5 hover:shadow-[0_10px_40px_rgba(106,30,39,0.08)] hover:border-[#6A1E27]/40 transition-all h-full"
              >
                <ShieldCheck className="w-10 h-10 text-[#6A1E27]" />
                <div className="flex-1">
                  <div className="font-display text-2xl md:text-3xl text-[#1A1A1A]">{c.code}</div>
                  <div className="text-sm uppercase tracking-[0.18em] text-[#C4A27A] mt-2">{c.label}</div>
                </div>
                <span className="inline-flex items-center gap-2 text-sm text-[#6A1E27] mt-2 group-hover:gap-3 transition-all">
                  <FileText className="w-4 h-4" />
                  {t.quality.viewCert}
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mt-20 border-y border-[#E5DFD3] py-8">
        <Marquee speed={40} gradient={false} pauseOnHover>
          {["TÜV AUSTRIA CERTIFIED", "ISO 9001:2015", "ISO 22000:2018", "HACCP:2003", "FOOD SAFETY", "QUALITY ASSURED"].map(
            (txt, i) => (
              <span
                key={i}
                className="font-display text-2xl md:text-4xl text-[#1A1A1A]/30 mx-10 whitespace-nowrap"
              >
                {txt} <span className="text-[#6A1E27]/40 mx-6">✦</span>
              </span>
            )
          )}
        </Marquee>
      </div>
    </section>
  );
};

export default Quality;
